import { render, staticRenderFns } from "./SchoolEmployeeIndividualLeaveModal.vue?vue&type=template&id=60a0b6df&scoped=true&"
import script from "./SchoolEmployeeIndividualLeaveModal.vue?vue&type=script&lang=js&"
export * from "./SchoolEmployeeIndividualLeaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0b6df",
  null
  
)

export default component.exports